module.exports = __webpack_public_path__ + "fonts/hk-grotesk.bold.cc608387.ttf";